import map_light from ".././images/Map_light.png";
import '../styles/pages/Location.css';


function Location() {
  return (
    <div className="location">
      <div className="map_info">
        <a className="directions" href="https://www.google.com/maps/place/5001+SE+Brooklyn+St+B,+Portland,+OR+97206/@45.5010158,-122.6118324,17z/data=!4m6!3m5!1s0x5495a066d17c4bf5:0x6b9ddf25db0a836c!8m2!3d45.5011595!4d-122.610865!16s%2Fg%2F11qg0y14rg?entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D" rel="noreferrer" target="_blank">
          <p>
            Directions
          </p>
        </a>

      {/* <iframe src="https://www.google.com/maps/place/5001+SE+Brooklyn+St+B,+Portland,+OR+97206/@45.5011632,-122.6134399,17z/data=!3m1!4b1!4m6!3m5!1s0x5495a066d17c4bf5:0x6b9ddf25db0a836c!8m2!3d45.5011595!4d-122.610865!16s%2Fg%2F11qg0y14rg?entry=ttu&g_ep=EgoyMDI2MDMxNS4wIKXMDSoASAFQAw%3D%3D" width="100%" height="300" style="border:0;" loading="lazy" referrerpolicy="no-referrer-when-downgrade" data-once="iframe-title" title="Google Maps embedded map"></iframe> */}
      <a href="https://www.google.com/maps/place/5001+SE+Brooklyn+St+B,+Portland,+OR+97206/@45.5010158,-122.6118324,17z/data=!4m6!3m5!1s0x5495a066d17c4bf5:0x6b9ddf25db0a836c!8m2!3d45.5011595!4d-122.610865!16s%2Fg%2F11qg0y14rg?entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D" rel="noreferrer" target="_blank">
          
        <img className="map_image" src={map_light} alt="Map"/>
      </a>
      {/* </div>
      <div className="map_info"> */}
        <p>
          5001 SE Brooklyn St., Ste B
        </p>
        <p>
          Portland, OR, 97206
        </p>
      </div>
    </div>
  );
}
export default Location;